/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfByte } from "../models/AjaxResponseOfByte";
import type { AjaxResponseOfContractsDto } from "../models/AjaxResponseOfContractsDto";
import type { AjaxResponseOfListOfComboboxItemDto } from "../models/AjaxResponseOfListOfComboboxItemDto";
import type { EditContractDto } from "../models/EditContractDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class ContractsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Success
   * @throws ApiError
   */
  public updateContract({
    requestBody,
  }: {
    requestBody?: EditContractDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/contracts/editar-contrato",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfContractsDto
   * @throws ApiError
   */
  public getContractById({
    id,
  }: {
    id?: number;
  }): CancelablePromise<AjaxResponseOfContractsDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/buscar-contrato-por-id",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfComboboxItemDto
   * @throws ApiError
   */
  public getAll(): CancelablePromise<AjaxResponseOfListOfComboboxItemDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/buscar-todos-contrados",
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public termoDeResponsabilidadeVendedor({
    vehicleId,
    userId,
    companyId,
    contractDate,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    contractDate?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/termo-de-responsabilidade-vendedor",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        contractDate: contractDate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public procuracaoDeClausula({
    vehicleId,
    userId,
    companyId,
    attorneyId,
    contractDate,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    attorneyId?: number;
    contractDate?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/procuracao-de-clausula",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        attorneyId: attorneyId,
        contractDate: contractDate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public termoDeResponsabilidadeTestDrive({
    vehicleId,
    companyId,
    userId,
    contractDate,
    testDriveDate,
  }: {
    vehicleId?: string;
    companyId?: number;
    userId?: number;
    contractDate?: string;
    testDriveDate?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/termo-de-responsabilidade-test-drive",
      query: {
        vehicleId: vehicleId,
        companyId: companyId,
        userId: userId,
        contractDate: contractDate,
        testDriveDate: testDriveDate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public termoDeResponsabilidadeComprador({
    vehicleId,
    userId,
    companyId,
    contractDate,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    contractDate?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/termo-de-responsabilidade-comprador",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        contractDate: contractDate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public checkList({
    vehicleId,
    userId,
    companyId,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/check-list",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public envelope({
    vehicleId,
  }: {
    vehicleId?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/envelope",
      query: {
        vehicleId: vehicleId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public promissoria({
    companyId,
    vehicleId,
    userId,
    currentPromissory,
    totalPromissory,
    contractDate,
    contractReal,
  }: {
    companyId?: number;
    vehicleId?: string;
    userId?: number;
    currentPromissory?: number;
    totalPromissory?: number;
    contractDate?: string;
    contractReal?: number;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/promissoria",
      query: {
        companyId: companyId,
        vehicleId: vehicleId,
        userId: userId,
        currentPromissory: currentPromissory,
        totalPromissory: totalPromissory,
        contractDate: contractDate,
        contractReal: contractReal,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public termoDeCiencia({
    vehicleId,
    userId,
    companyId,
    contractDate,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    contractDate?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/termo-de-ciencia",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        contractDate: contractDate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public compraVeiculo({
    vehicleId,
    userId,
    companyId,
    contractDate,
    contractReal,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    contractDate?: string;
    contractReal?: number;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/compra-veiculo",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        contractDate: contractDate,
        contractReal: contractReal,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public termoDeGarantia({
    vehicleId,
    userId,
    companyId,
    contractDate,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    contractDate?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/termo-de-garantia",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        contractDate: contractDate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public reciboPagamento({
    contractDate,
    receiptNumber,
    vehicleId,
    userId,
    companyId,
    formOfPayment,
  }: {
    contractDate?: string;
    receiptNumber?: number;
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    formOfPayment?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/recibo-pagamento",
      query: {
        contractDate: contractDate,
        receiptNumber: receiptNumber,
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        formOfPayment: formOfPayment,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public termoDeRescisaoContratualEOutrasAvencasInput({
    vehicleId,
    userId,
    companyId,
    contractDate,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    contractDate?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/termo-de-rescisao-contratual-e-outras-avencas-input",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        contractDate: contractDate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public contratoCompraVendaVeiculo({
    vehicleId,
    userId,
    companyId,
    contractDate,
    documentName,
    contractReal,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    contractDate?: string;
    documentName?: string;
    contractReal?: number;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/contrato-compra-venda-veiculo",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        contractDate: contractDate,
        documentName: documentName,
        contractReal: contractReal,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public entregaDeDocumentos({
    vehicleId,
    userId,
  }: {
    vehicleId?: string;
    userId?: number;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/entrega-de-documentos",
      query: {
        vehicleId: vehicleId,
        userId: userId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public consignacao({
    vehicleId,
    userId,
    companyId,
    formerOwnerName,
    formerOwnerCgc,
    contractReal,
    contractDate,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    formerOwnerName?: string;
    formerOwnerCgc?: string;
    contractReal?: number;
    contractDate?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/consignacao",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        formerOwnerName: formerOwnerName,
        formerOwnerCgc: formerOwnerCgc,
        contractReal: contractReal,
        contractDate: contractDate,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public repasse({
    vehicleId,
    userId,
    companyId,
    contractDate,
    contractReal,
    formerOwnerName,
    formerOwnerCgc,
  }: {
    vehicleId?: string;
    userId?: number;
    companyId?: number;
    contractDate?: string;
    contractReal?: number;
    formerOwnerName?: string;
    formerOwnerCgc?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/repasse",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        companyId: companyId,
        contractDate: contractDate,
        contractReal: contractReal,
        formerOwnerName: formerOwnerName,
        formerOwnerCgc: formerOwnerCgc,
      },
    });
  }

  /**
   * @returns AjaxResponseOfByte<any>
   * @throws ApiError
   */
  public procuracao({
    vehicleId,
    userId,
    attorneyId,
    contractDate,
    receivedDate,
    refundDate,
  }: {
    vehicleId?: string;
    userId?: number;
    attorneyId?: number;
    contractDate?: string;
    receivedDate?: string;
    refundDate?: string;
  }): CancelablePromise<AjaxResponseOfByte> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/contracts/procuracao",
      query: {
        vehicleId: vehicleId,
        userId: userId,
        attorneyId: attorneyId,
        contractDate: contractDate,
        receivedDate: receivedDate,
        refundDate: refundDate,
      },
    });
  }
}
